import React, { Component } from 'react'
import ModuleCard from '../ModuleCard'
import HttpClient from "../../../libs/http";
const http = new HttpClient()
const qs = require('query-string')
const query = qs.parse(window.location.search)

query.environment = query.environment || 'stable'

export default class ModulesPanel extends Component {
  constructor(props) {
    super(props)
    this.worker = null
    this.state = {
      modules: [],
      showStopped: false,
      last_updated: new Date().toString("HH:mm:ss"),
      loaded: false
    }
  }

  componentDidMount() {
    this.getData()
    this.worker = setInterval(async _ => await this.getData(), 30000)
  }

  componentWillUnmount() {
    if (this.worker) clearInterval(this.worker)
  }

  getData = async () => {
    try {
      let modules = await http.GET(`/api/pvt/healthcheck/modules?repository=${query.environment}`)
      let new_state = this.state
      new_state.modules = modules
      new_state.last_updated = new Date().toString("HH:mm:ss")
      new_state.loaded = true
      this.setState(new_state)
    }
    catch (err) {
      console.log(err)
    }
  }

  onCheckShowStopped = () => {
    this.setState(prevState => ({
      showStopped: !prevState.showStopped
    }))
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="loading-full">
          <section className="mw5 mw5-ns center">
          </section >
        </div>
      )
    }

    const modules = this.state.showStopped
      ? this.state.modules
      : this.state.modules.filter(x => x.status !== 'stopped')

    const lastResult = modules && modules.length > 0
      ? modules[0].lastResult
      : null

    return (
      <div>
         {query.environment !== 'stable' 
            ? <article className="w-100 tc f1 fw9 pa6 bg-washed-blue dark-gray center ba shadow-5 br2 pv2 pl2 pl0-ns">This tests are running on environment {query.environment.toUpperCase()}</article>
            : false
          }
        {lastResult &&
          <h1 className="normal">Last result: {new Date(lastResult).toString("HH:mm")}</h1>
        }
        <div className="flex-l">
          <div className="flex flex-wrap flex-start item-stretch">
            {modules.map((module, index) => (
              <div key={`module_${module.id}`}
                    className='self-stretch w-100 w-50 w-30-ns w-20-xl b--black-10 pa1'>
                <ModuleCard module={module} environment={query.environment} />
              </div>
            ))}
            <div className="w-100 tr">
              <input type="checkbox" id="stopped" value="stopped" checked={this.state.showStopped} onClick={this.onCheckShowStopped} />
              <label className="mr2 ml2">Show stopped modules</label>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Healthcheck/ModulesPanel/index.js